import React from "react";
import "semantic-ui-css/semantic.min.css";
import { Button } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";

const Error404 = () => {
  const navigate = useNavigate();
  const handleRegresarClick = () => {
    navigate("/");
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <h1>Página no encontrada 404</h1>
      <Button
        onClick={handleRegresarClick}
        primary
        style={{ marginTop: "12px" }}
      >
        Regresar
      </Button>
    </div>
  );
};

export default Error404;
